import React from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import { HeadProvider } from "react-head";
import ThankYou from "../src/components/common/ThankYouPage";
import 'bootstrap/dist/css/bootstrap.min.css';
import PrivacyPolicyModal from "./components/common/privacyPolicy";
import SEOManager from "./SeoManager";

import "./assets/css/style.css";
import Home from "./pages/home";
import FloatingButtons from "./components/common/enquiry-logo";


function App() {
  const location = useLocation();
  const state = location.state;

  return (
    <>
  <HeadProvider>
    <SEOManager />
      <FloatingButtons />
      <Routes location={state?.backgroundLocation || location}>
        <Route path="/" element={<Home />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>

      {/* Modal Route */}
      {state?.backgroundLocation && (
        <Routes>
          <Route path="/privacy" element={<PrivacyPolicyModal />} />
        </Routes>
      )}
      </HeadProvider>
    </>
  );
}

export default App;
